"use client";

import { CardContent, CardHeader } from "@/components/ui/card";
import LoginForm from "./login-form";

const LoginComponent = () => {
    return (
        <>
            <CardHeader className="pb-0 px-4 sm:px-6"></CardHeader>
            <CardContent className="px-4 sm:px-6">
                <LoginForm />
            </CardContent>
        </>
    );
};

export default LoginComponent;
